import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgLearn = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 74.87 83.98",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M47.49,69.07h-20.11c-1.24,0-2.25-1.01-2.25-2.25v-8.79c-7.25-4.33-11.69-12.1-11.69-20.59,0-13.23,10.77-24,24-24s24,10.77,24,24c0,8.5-4.45,16.26-11.69,20.59v8.79c0,1.24-1.01,2.25-2.25,2.25ZM29.63,64.57h15.61v-7.86c0-.84.47-1.6,1.21-1.99,6.47-3.38,10.49-10,10.49-17.28,0-10.75-8.75-19.5-19.5-19.5s-19.5,8.75-19.5,19.5c0,7.28,4.02,13.9,10.49,17.28.74.39,1.21,1.16,1.21,1.99v7.86Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M47.37,76.53h-19.88c-2.98,0-2.98-4.5,0-4.5h19.88c2.98,0,2.98,4.5,0,4.5Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M43.9,83.98h-12.94c-2.98,0-2.98-4.5,0-4.5h12.94c2.98,0,2.98,4.5,0,4.5Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M35.18,7.73V2.23c0-2.98,4.5-2.98,4.5,0v5.5c0,2.98-4.5,2.98-4.5,0Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M14.84,18.02l-3.89-3.89c-2.11-2.11,1.08-5.29,3.18-3.18l3.89,3.89c2.1,2.11-1.09,5.27-3.18,3.18Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M7.73,39.68H2.23c-2.98,0-2.98-4.5,0-4.5h5.5c2.98,0,2.98,4.5,0,4.5Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M10.95,60.73l3.89-3.89c2.11-2.11,5.29,1.08,3.18,3.18l-3.89,3.89c-2.11,2.11-5.29-1.08-3.18-3.18Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M56.84,14.84l3.89-3.89c2.11-2.11,5.29,1.08,3.18,3.18l-3.89,3.89c-2.09,2.09-5.29-1.08-3.18-3.18Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M72.63,39.68h-5.5c-2.98,0-2.98-4.5,0-4.5h5.5c2.98,0,2.98,4.5,0,4.5Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M60.73,63.92l-3.89-3.89c-2.11-2.11,1.08-5.29,3.18-3.18l3.89,3.89c2.1,2.11-1.08,5.29-3.18,3.18Z" })
	]
});
export default SvgLearn;
